import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=4583b7e3"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=4583b7e3&prod&lang=css"
import style1 from "./Info.vue?vue&type=style&index=1&id=4583b7e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports